import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import {sendPaymentSuccessEmail} from "../../utility/emailUtility";

const PaymentSuccess = () => {
    const { orderID } = useParams();
    const navigate = useNavigate();

    const [buyerData, setBuyerData] = useState([]);

                

    const userInfo = JSON.parse(localStorage.getItem('user-info'));
            // Fetch buyer addresses using buyer_id
            useEffect(() => {
                getBuyerDetails();  // Call the function on component load
            }, []);

    const getBuyerDetails = async () => {
        
        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Get-GetBuyerDetailsByBuyerID?buyerID=${userInfo.buyer_id}`);
                
                const dataBuyer = await response.json();

                if (dataBuyer) {

                    setBuyerData(dataBuyer);  // Bind the fetched Buyer Data

                    // Access buyerName and buyerMail from dataBuyer
                    const { buyerName, buyerMail } = dataBuyer[0];

                    if (buyerName && buyerMail) {
                        const success = await sendPaymentSuccessEmail(buyerName, buyerMail, orderID);
                  
                        if (success) {
                            alert("Payment Initiated !! Please Check your Email !!");
                        } else {
                            alert("Payment Initiated, but failed to send email.");
                        } 
                    }
                }

            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        }

    };


    return (
        <>
            <div className="pt-3 pb-3 mb-3 border-bottom">
                <div className="container">
                    <a className="logo" href="/"><img src="../../../images/logo-icon.png" alt="" /><span>Indi<span>G</span>alleria</span></a>
                </div>
            </div>

            <div className='container'>
                <div className='row'>
                    <div className='col-sm-8 m-auto'>
                        <div className='text-center p-4 border mt-4 mb-5'>
                            <span className='successicon'><i className="bi bi-patch-check-fill"></i></span>
                            <h2>Payment Successful!</h2>
                            <p className='text-center'>Your payment has been successfully processed.<br/>Thank you for your purchase!</p>
                            <button className='btn2 bg-primary text-white border-0 mt-3' onClick={() => navigate(`/orderSummary/${orderID}`)}>Go to Order Summary</button>
                        </div>
                    </div>
                </div>

            </div>

            <footer>
                <div className="container">
                    <ul className="pay_icon">
                        <li><img src="../images/payment/Mastercard.svg" /></li>
                        <li><img src="../images/payment/visa.svg" /></li>
                        <li><img src="../images/payment/visa-electron.svg" /></li>
                    </ul>
                    <ul className="ftr_link">
                        <li><a href="#">+91-9555511765</a></li>
                        <li><a href="#">Home</a></li>
                        <li><a href="#">About Company</a></li>
                    </ul>
                    <div className="copyright text-center">
                        <span className="bi bi-c-circle"></span> 2017-2024 IndiGalleria. All rights reserved.
                    </div>
                </div>
            </footer>
        </>

    );
};

export default PaymentSuccess;
